import { render, staticRenderFns } from "./HomeBaike.vue?vue&type=template&id=00ffe216&scoped=true&"
import script from "./HomeBaike.vue?vue&type=script&lang=js&"
export * from "./HomeBaike.vue?vue&type=script&lang=js&"
import style0 from "./HomeBaike.vue?vue&type=style&index=0&id=00ffe216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ffe216",
  null
  
)

export default component.exports